import _cloneDeep from 'lodash-es/cloneDeep';
import _values from 'lodash-es/values';
import _set from 'lodash-es/set';
import _get from 'lodash-es/get';
import _keys from 'lodash-es/keys';
import _forEach from 'lodash-es/forEach';
import _find from 'lodash-es/find';
import _matches from 'lodash-es/matches';
import _last from 'lodash-es/last';
import _isObject from 'lodash-es/isObject';
import _pull from 'lodash-es/pull';
import _unset from 'lodash-es/unset';
import _toString from 'lodash-es/toString';
import _findIndex from 'lodash-es/findIndex';
import _pullAt from 'lodash-es/pullAt';
import _split from 'lodash-es/split';
import _differenceBy from 'lodash-es/differenceBy';
import _filter from 'lodash-es/filter';
import _toNumber from 'lodash-es/toNumber';
import _findKey from 'lodash-es/findKey';
import _isString from 'lodash-es/isString';
import _startsWith from 'lodash-es/startsWith';

import * as moment from 'moment';
import { commonApiLabels } from "libraries/const/commonApiLabels";
//Vanilla
import { Yii } from "libraries/interfaces/Yii";
// Core modules
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
//Services
import { TnrService } from "../../service/tnr/tnr.service";
import { SynchronymeService } from "../../service/synchronyme/synchronyme.service";
import { IRequestContainer, PnrService } from "../../service/pnr/pnr.service";
import { SelectService } from 'libraries/service/select/select.service';
import { INameList, INameListWording } from "../../service/synchronyme/INameList.interface";
import { ILabels } from "libraries/interfaces/ILabels";
import { GroupResourceService } from "libraries/service/resources/group/groupResource.service";
import { LabelService } from "libraries/service/label/label.service";
import { Subscription } from 'rxjs';
import { INotification, NotificationType } from 'libraries/interfaces/INotification';
import { faPaperPlane, faPlus, faTimes, faUserPlus, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { PermissionResourceService } from "../../../libraries/service/resources/permission/permissionResource.service";

declare var wenji: any;

interface IActionsStatus {
    pending: IActionStatus;
    error: IActionStatus;
    success: IActionStatus;
}

interface IActionStatus {
    type?: ActionTypes;
    isCurrentStatus: boolean;
    index?: number;
    message?: string;
}

enum ActionTypes {
    patchPnrAir = 'PatchPnrAir',
    createPnr = 'CreatePnr',
    updatePnr = 'UpdatePnr',
}

class WordingClass {
    public readonly company: string = Yii.t('wui-skn-js', 'Compagnie :');
    public readonly departure: string = Yii.t('wui-skn-js', 'Départ :');
    public readonly from: string = Yii.t('wui-skn-js', 'De');
    public readonly to: string = Yii.t('wui-skn-js', 'vers');
}

@Component({
    selector: 'pnr-list',
    templateUrl: 'pnrlist.component.html',
    styleUrls: ['pnrlist.component.scss']
})
export class PnrListComponent implements OnInit, OnDestroy {

    public Yii = Yii;
    public apiLabels: ILabels = commonApiLabels;
    public uiLabels: ILabels = {
        create: Yii.t('wui-skn-js', 'Créer un %placeholder%'),
    };

    public nameListsConfig: INameList[];
    public completeLabel: any;

    public customWording: WordingClass = new WordingClass();

    @ViewChild('sendPlaneButton') sendPlaneButton: ElementRef;


    /**
     * gePnrList
     *
     * get dummy data if typed in url. Launched at startUp if midOfficeRef is set on url
     *
     * @param {string} _id : jsonblob id or json file name (no extension)
     *                       default : this.urlParams.PNRId (from url)
     */
    public pnrPending: boolean = false;
    public pnrError: boolean = false;
    public pnrErrorMessage: string;
    public nameLists: any[] = [];
    public futureNamelists: any[] = [];
    public actionName: string | INameList;
    public futureActionName: string[] = [];

    //flag vars
    public f_remainingError: any = {};
    public f_showForm: boolean = false;
    public f_showNewNamelistButton: boolean = true;

    public wording: any = {};

    public actionStatus: IActionsStatus = this.setActionStatus();

    // forms input ngModels references
    public quantityPnr = null;
    public inputPnr = '';
    public futureInputPnr: string[] = [];
    public futureQuantityPnr: number[] = [];
    public readonly routeParams: any = {};
    public readonly urlParams: any = {};
    public updatedPax: boolean = false;
    public readonly isString: any;
    public errorNotification: INotification = {
        active: false,
        type: NotificationType.Error,
        message: Yii.t('wui-skn-js', "La configuration de votre instance n'a pas été correctement chargée")
    };

    public bookingJourney: any = null;
    public canCreateJourneyPermission: boolean = false;

    public iconSendPlane: IconDefinition = faPaperPlane;

    public iconUserPlus: IconDefinition = faUserPlus;

    public iconTimes: IconDefinition = faTimes;

    public iconPlus: IconDefinition = faPlus;

    //service vars
    private readonly s_listData: any;
    private readonly s_appData: any;

    /**
     * @type {Subscription}
     * @private subscription
     */
    private subscription: Subscription;
    private subscription2: Subscription;
    private subscription3: Subscription;

    constructor(
        private readonly tnrService: TnrService,
        private readonly pnrService: PnrService,
        private readonly synchronymeService: SynchronymeService,
        private readonly select: SelectService,
        private readonly groupResource: GroupResourceService,
        private readonly labelService: LabelService,
        private readonly permissionResourceService: PermissionResourceService
    ) {
        this.s_listData = select.data;
        this.s_appData = synchronymeService.data;
        this.isString = synchronymeService.isString;
        this.completeLabel = labelService.completeLabel;
    }

    /* LIVECYCLE */

    public ngOnInit(): void {
        this.permissionResourceService.hasPermission("skn.namelist.journey.create").subscribe(
            (result: boolean): boolean => this.canCreateJourneyPermission = result);

        if (this.s_appData.urlParams.PNRId) {
            this.getPnrList(this.s_appData.urlParams.PNRId);
        }

        this.synchronymeService.getNamelists()
            .subscribe(
                (nameLists) => {
                    this.nameListsConfig = nameLists;
                },
                (error: Error) => {
                    this.errorNotification.active = true;
                }
            );

        this.subscription = this.pnrService.showPnrEvent
            .subscribe(
                (_id: any) => {
                    this.getPnrList(_id);
                },
                (error: Error) => console.error(error.message)
            );

        this.subscription2 = this.pnrService.showNamelistOrNamelistEvent
            .subscribe(
                (_id: any) => {
                    this.f_showNewNamelistButton = false;
                    this.getNamelistOrMidofficeApi(_id.toString());
                },
                (error: Error) => console.error(error.message)
            );

        this.subscription3 = this.pnrService.showFutureNamelists
            .subscribe(
                (namelists) => {
                    this.futureNamelists = namelists;
                },
                (error: Error) => console.error(error.message)
            );

        this.wording = wenji.synchronyme.wording;
    }

    public ngOnDestroy(): void {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        if (this.subscription2) {
            this.subscription2.unsubscribe();
        }
    }

    public clickOnSendButtons(): void {
        const btns = document.getElementsByClassName(
            'sendButton',
        ) as HTMLCollectionOf<HTMLElement>;

        for (let i = 0; i < btns.length; i++) {
            btns[i].querySelector('button').click();
        }
    }

    /**
     * add nr List
     *
     * add a PNR to the list, launched from response observable
     */
    public addPnrList(_data: any, _futureIndex?: number): void {
        let namelist = _cloneDeep(_data);
        if (!namelist.traveller && !namelist.booking) {
            namelist = _values(namelist)[0];
        }

        if (_futureIndex !== undefined) {
            namelist.futurIndex = _futureIndex;
        }

        if (!namelist.traveller) {
            const tempObj: any = {};
            namelist.traveller = tempObj;
        }
        if (namelist.booking) {
            this.setStock(namelist);
        }

        this.nameLists.push(namelist);

        this.f_showForm = false;

        if (this.s_appData.tnrCollection) {
            this.compareTraveller(namelist);
        }

        this.synchronymeService.setPnrNb(this.nameLists.length);

    }

    /**
     *
     * create a Stock object
     *
     */
    public setStock(_namelist: any): any {
        const quantity = _values(_values(_namelist.sector)[0].seat)[0].quantity;
        _set(_namelist, 'stock.Purchased.quantity', quantity);
        _set(_namelist, 'stock.Purchased.remaining', quantity - _keys(_namelist.traveller).length);
    }

    /**
     * update pnr List
     *
     * add a TNR to the list, launched from response observable
     */
    public updatePnrList(_data: any, _index: number): void {

        this.nameLists[_index] = _data;

        this.updateTnrPax(_index);

        this.f_showForm = false;
    }

    /**
     *
     *
     * Update Origin Tnr Pax
     */
    public updateTnrPax(_index: number) {
        const namelist = this.nameLists[_index];
        const tempBooking = this.getTempBooking(namelist);
        _set(tempBooking, 'id', _get(namelist, 'journey.id'));
        const tempJourney: any = {};
        _forEach(namelist.traveller, (_pax: any, _paxId: any) => {
            const tnrId = _pax.booking.code;
            if (!tempJourney[tnrId]) {
                tempJourney[tnrId] = {};
            }
            _set(tempJourney[tnrId], _pax.xID, tempBooking);
            _set(tempJourney, 'reference', 'xID');
            _set(tempJourney, [tnrId, _pax.xID, 'id'], _get(namelist, 'journey.id'));
        });
        this.tnrService.showJourneyFlag(tempJourney);

    }

    public compareTraveller(_namelist: any): void {
        _forEach(_namelist.traveller, (_groupPax: any, _id: string) => {
            const originTnrId = _get(_groupPax, ['booking', 'code']);

            // const tnrPax = this.s_appData.tnrCollection[originTnrId].traveller[_id];
            const tnrPax = _get(this.s_appData, ['tnrCollection', originTnrId, 'traveller', _id]);
            if (tnrPax) {
                if (!this.synchronymeService.isSameTraveller(tnrPax, _groupPax)) {
                    const diff: any = this.synchronymeService.getTravellerDifference(tnrPax, _groupPax);
                    if (diff.title && diff.title === "Mr") {
                        diff.gender = "Male";
                    } else if (diff.title && diff.title !== "Mr") {
                        diff.gender = "Female";
                    }
                    if (_keys(diff).length > 0) {
                        this.updatedPax = true;
                        _groupPax.dataToPatch = diff;
                    }
                }
            }
        });
    }


    /**
     * Remove Pnr List
     *
     * remove a PNR from the list, launched from response observable
     */
    public removePnrList(_index: number): void {
        if (this.nameLists.length === 1 && !this.f_showNewNamelistButton) {
            this.f_showNewNamelistButton = true;
        }

        if (this.nameLists[_index].futurIndex !== undefined) {
            this.futureNamelists[this.nameLists[_index].futurIndex].done = false;
        }

        _forEach(this.nameLists[_index].traveller, (_traveller: any) => {
            if (_traveller.isAdded) {
                this.removePax(_toString(_traveller.id), _index);
            }
        });
        _pullAt(this.nameLists, [_index]);
        this.synchronymeService.setPnrNb(this.nameLists.length);
    }

    /**
     * isDisplayedList
     *
     * @param {string} _id : id of the tnr list to be tested
     *
     */
    public isDisplayedNameList(_name: string): boolean {
        // let output: boolean= true;
        const index = _findIndex(this.nameLists, (_val: any) => {
            return this.getName(_val) === _name;
        });

        return index > -1;
    }

    /**
     * isDisplayedList
     *
     * used to know if pax are selected in tnr list
     *
     */
    public isSelectedPax(): boolean {
        const paxToAdd = this.removeDisabled();

        return _find(paxToAdd, (o: any) => {
            return o.length > 0;
        });
    }

    public hasLinkedPnr(element: any): boolean {
        return element?.journey?.booking && Boolean(Object.values(element.journey.booking).filter((booking: any) => booking.type  === 'PNR').length);
    }


    /**
     * getBookingId
     *
     * get the bookinId from a TNR object
     *
     * @param {any} _tnr : _tnr object
     * @returns {string} : booking Id
     *
     */
    public getBookingId(_tnr: any): string {
        return _findKey(_tnr, _matches({'topic': 'Booking'}));
    }

    public getPnrList(_id: string, _futureIndex?: number): void {
        //before to send RQ, test if the pnr is not already in list
        const isOnList = _find(this.nameLists, (nl) => {
            if (nl.topic === "Journey") {
                return _find(nl.journey.booking, (booking): boolean => booking.code ===_id);
            } else if (nl.topic === "Booking") {
                return _find(nl.booking.code, (code): boolean => code ===_id);
            }
        });

        if (!isOnList) {
            this.pnrPending = true;
            this.groupResource.getPnr(_id)
                .subscribe((data) => {
                        if (this.synchronymeService.hasSameJourney(data) || this.s_appData.bookingJourney || _futureIndex !== undefined) {
                            this.addPnrList(data, _futureIndex);
                        } else {
                            this.setPnrError(Yii.t('wui-skn-js', "Trajet différent"));
                        }
                        this.pnrPending = false;
                    },
                    (error: Error) => {
                        this.setPnrError(error.message);
                    },
                    () => {
                        this.pnrPending = false;
                    });
        } else {
            this.setPnrError(Yii.t('wui-skn-js', "L'export est déjà affiché"));
        }
    }

    public getNamelistOrMidofficeApi(_id: string): void {

        //before to send RQ, test if the pnr is not already in list
        const isOnList = _find(this.nameLists, (nl) => _id === nl.journey.id);

        if (!isOnList) {
            this.pnrPending = true;
            this.groupResource.getNameList(_id)
                .subscribe((data) => {
                        this.addPnrList(data);
                        //update travellers
                        this.updateTnrPax(this.nameLists.length - 1);
                        this.pnrPending = false;
                    },
                    (error: Error) => {
                        this.setPnrError(error.message);
                    },
                    () => {
                        this.pnrPending = false;
                    });

        } else {
            this.setPnrError(Yii.t('wui-skn-js', "L'export est déjà affiché"));
        }
    }


    public setPnrError(message?: string, _index?: number) {
        this.pnrPending = false;
        this.pnrError = true;
        this.pnrErrorMessage = message ? message : this.apiLabels.error;
    }

    /***
     * patchPnrAir
     *
     *
     * @param {number} _id : jsonblob id or json file name (no extension)
     *                       default : this.urlParams.PNRId (from url)
     */
    public patchPnrAir(index: number): void {
        this.changeActionStatus('pending', {
            isCurrentStatus: true,
            index,
            type: ActionTypes.patchPnrAir
        });

        const rqContainer = this.pnrService.createPatchRq(this.nameLists[index]);

        this.groupResource.createPnr(rqContainer.rq)
            .subscribe(
                (data) => {
                    this.updatePnrList(data, index);
                    this.changeActionStatus('success', {
                        isCurrentStatus: true,
                        index,
                        type: ActionTypes.patchPnrAir,
                    });

                },
                (error: Error) => {
                    this.changeActionStatus('error', {
                        isCurrentStatus: true,
                        index,
                        type: ActionTypes.patchPnrAir,
                        message: error.message,
                    });
                }
            );

    }

    /**
     * createPnr
     *
     * get dummy data if typed in url. Launched at startUp if midOfficeRef is set on url
     *
     * @param {any} _query : json object
     */
    public createPnr(index: any): void {
        const namelist = _cloneDeep(this.nameLists[index]);
        this.changeActionStatus('pending', {
            isCurrentStatus: true,
            index,
            type: ActionTypes.createPnr
        });

        const request: IRequestContainer = namelist.booking ? this.pnrService.requestIfLoadedPnr(namelist) : namelist;

        this.groupResource.createPnr(request)
            .subscribe(
                (data: any) => {
                    this.updatePnrList(data[0], index);
                    this.changeActionStatus('success', {
                        isCurrentStatus: true,
                        index,
                        type: ActionTypes.createPnr,
                    });
                },
                (error: Error) => {
                    this.changeActionStatus('error', {
                        isCurrentStatus: true,
                        index,
                        type: ActionTypes.createPnr,
                        message: error.message,
                    });
                });


    }

    /**
     * updateJourney
     *
     * update journey with new PNR created
     *
     * @param {Number} _midOfficeRef
     * @param {any} _query : json object
     */
    public updateJourney(index: any): void {
        const namelist = _cloneDeep(this.nameLists[index]);
        this.changeActionStatus('pending', {
            isCurrentStatus: true,
            index,
            type: ActionTypes.createPnr
        });

        let id = this.bookingJourney.journey.id;

        if (this.nameLists[index].futurIndex !== undefined) {
            id = this.futureNamelists[this.nameLists[index].futurIndex].data.journey.id;
        }

        this.groupResource.updateJourney(id, namelist)
            .subscribe(
                (data: any) => {
                    this.updatePnrList(data[0], index);
                    this.changeActionStatus('success', {
                        isCurrentStatus: true,
                        index,
                        type: ActionTypes.createPnr,
                    });
                },
                (error: Error) => {
                    this.changeActionStatus('error', {
                        isCurrentStatus: true,
                        index,
                        type: ActionTypes.createPnr,
                        message: error.message,
                    });
                });


    }

    /***
     * updatePnr
     *
     * get dummy data if typed in url. Launched at startUp if midOfficeRef is set on url
     *
     * @param {any} _query : json object
     */
    public updatePnr(index: any): void {
        this.changeActionStatus('pending', {
            isCurrentStatus: true,
            index,
            type: ActionTypes.updatePnr
        });

        const rq = this.pnrService.createUpdatePnr(this.nameLists[index]);

        rq.rq.journey = {
            booking: _values(this.nameLists[index].journey.booking).filter(item => Boolean(item.traveller))[0]
        };

        this.groupResource.patchPnr(rq.id, rq.rq)
            .subscribe(
                (data) => {
                    this.updatePnrList(data[0], index);
                    this.changeActionStatus('success', {
                        isCurrentStatus: true,
                        index,
                        type: ActionTypes.updatePnr,
                    });
                },
                (error: Error) => {
                    this.changeActionStatus('error', {
                        isCurrentStatus: true,
                        index,
                        type: ActionTypes.updatePnr,
                        message: error.message,
                    });
                }
            );
    }

    /**
     * getName
     *
     * get the journey Name from a PNR object
     *
     * @param {any} _journey : _tnr object
     * @returns {string} : booking Id
     *
     */
    public getName(_namelist: any): string | INameList {
        let namelist = _cloneDeep(_namelist);

        if (!namelist.traveller && !namelist.booking) {
            namelist = _values(namelist)[0];
        }
        if (this.isJourney(namelist)) {
            return this.getJourneyName(namelist);
        } else {
            return this.getPnrName(namelist);
        }
    }

    /**
     *
     *
     * get full string name of a Journey (PNR)
     */
    public getJourneyName(_namelist: any): string {
        let output: any;
        let booking: any = {};
        if (_namelist.journey.booking.type) {
            booking = _namelist.journey.booking;
        } else {
            //booking = _values(_namelist.journey.booking)[0];
            booking = _values(_namelist.journey.booking).filter(item => Boolean(item.traveller))[0] ?? _values(_namelist.journey.booking)[0];
        }

        if (booking.type === "PNR") {

            output = booking.type + " " + booking.host + " ";

            if (booking.isPassive) {
                output += Yii.t('wui-skn-js', 'Passif') + " ";
            } else {
                output += Yii.t('wui-skn-js', 'Actif') + " ";
            }

            if (booking.code) {
                output += booking.code;
            }


        } else if (booking.type === "NAMELIST") {
            output = this.getNamelist(_namelist);
        }
        return output;
    }

    /**
     *
     *
     * get full name of a Journey (PNR/Tigre)
     */
    public getNamelist(_namelist: any): any {

        let booking: any = {};
        const output: any = {};
        if (_namelist.journey.booking.type) {
            booking = _namelist.journey.booking;
        } else {
            booking = _values(_namelist.journey.booking).filter(item => Boolean(item.traveller))[0];
        }
        if (booking.url) {
            output.files = booking.url.map((url) => {
                return {
                    url,
                    file: _last(_split(booking.url, '/'))
                };
            });
        } else {
            output.files = [];
        }

        // WARNING : add new hosts (KUONI, LOGITO...) on config
        const bookingHost = _find(this.nameListsConfig, (nl) => nl.host === booking.host);
        output.wording = bookingHost ? bookingHost.wording.short : booking.host;

        return output;
    }

    public getPnrName(_namelist: any): string {
        let output;

        output = "PNR ";

        if (_isObject(_namelist.booking.code)) {
            output += _keys(_namelist.booking.code)[0] + " ";
        }

        if (_namelist.booking.isPassive) {
            output += Yii.t('wui-skn-js', 'Passif') + " ";
        } else {
            output += Yii.t('wui-skn-js', 'Actif') + " ";
        }

        output += this.getPnrCode(_namelist);

        return output;
    }

    public getOriginPaxList(_namelist: any): any {

        let namelist = _cloneDeep(_namelist);
        if (!namelist.traveller && !namelist.booking) {
            namelist = _values(namelist)[0];
        }

        return namelist.traveller;

    }

    /**
     * isJourney
     *
     * test if it is a journey or an air PNR
     *
     * @param {any} _data : response object to test
     * @returns {boolean} : true : isJourney / false: isPnr
     *
     */
    public isJourney(_data: any): boolean {
        return _data.topic && _data.topic === "Journey";
    }

    /**
     * addPax
     *
     * add a Pax in a PNR/Tigre list
     *
     * @param {number} _index : index from tnr List
     */
    public addPax(_index: number): void {
        this.addPaxInJourney(_index);
    }

    public addPaxInJourney(_index: number): void {
        this.errorNotification.active = false;
        //add a traveller object if not provided (empty PNR)
        if (!this.nameLists[_index].traveller) {
            this.nameLists[_index].traveller = {};
        }

        const tempBooking = this.getTempBooking(this.nameLists[_index]);

        //remove Disabled Pax from the list
        const paxToAdd = this.removeDisabled();

        const tempJourney: any = {};
        _forEach(paxToAdd, (paxIdList: any, idList: string) => {
            // find complet pax object with pax Id and Tnr Id
            const tnr = _get(this.s_appData, ['tnrCollection', idList]);
            //Don't insert if (nbToinsert > remaining)
            if ((this.nameLists[_index].stock && paxIdList.length > this.nameLists[_index].stock.Purchased.remaining)) {
                //show error message here
                this.errorNotification.message = Yii.t('wui-skn-js', 'Le nombre de voyageurs sélectionnés est trop élevé.');
                this.errorNotification.active = true;

            } else { // insert if (nbToinsert < remaining)

                _forEach(paxIdList, (paxId: string) => {

                    //add Pax to paxList
                    const tempPax = _cloneDeep(tnr.traveller[paxId]) || _cloneDeep(tnr.traveller[_toNumber(paxId)]);
                    if (!tempJourney[idList]) {
                        tempJourney[idList] = {};
                    }
                    _set(tempJourney[idList], paxId, tempBooking);
                    //add booking infos to Pax
                    tempPax.isAdded = true;
                    tempPax.booking = _cloneDeep(tnr.booking);
                    // #15086 modification
                    if (_isObject(tempPax.booking.code)) {
                        tempPax.booking.host = _keys(tempPax.booking.code)[0];
                        tempPax.booking.code = _values(tempPax.booking.code)[0];
                    }
                    tempPax.booking.status = "Confirm";
                    //Where to get the value ? I assume that the pax are always confirmed here

                    _set(this.nameLists[_index].traveller, paxId, tempPax);

                    //Desactivate from origin
                    if (!this.s_listData.listDisabled[idList]) {
                        this.s_listData.listDisabled[idList] = [];
                    }
                    this.s_listData.listDisabled[idList].push(paxId);

                });

                //update "remaining" value
                if (this.nameLists[_index].stock) {

                    this.nameLists[_index].stock.Purchased.remaining -= paxIdList.length;
                }

                //create and show journey info of pax in booking card
                this.tnrService.showJourneyFlag(tempJourney);

            }
        });

    }


    public addPaxInPnr(_index: number): void {
        this.errorNotification.active = false;
        //add a traveller object if not provided (empty PNR)
        if (!this.nameLists[_index].booking.traveller) {
            this.nameLists[_index].booking.traveller = {};
        }

        //remove Disabled Pax from the list
        const paxToAdd = this.removeDisabled();

        _forEach(paxToAdd, (paxIdList: any, idList: string) => {
            // find complet pax object with pax Id and Tnr Id
            const tnr = _get(this.s_appData, ['tnrCollection', idList]);
            //Don't insert if (nbToinsert > remaining)
            if ((this.nameLists[_index].stock && paxIdList.length > this.nameLists[_index].stock.Purchased.remaining)) {

                //show error message here
                this.errorNotification.message = Yii.t('wui-skn-js', 'Le nombre de voyageurs sélectionnés est trop élevé.');
                this.errorNotification.active = true;


            } else { // insert if (nbToinsert < remaining)

                _forEach(paxIdList, (paxId: string) => {
                    paxId = _toString(paxId); //insure string type

                    //add Pax to paxList
                    const tempPax = _cloneDeep(tnr.traveller[paxId]);

                    //add booking infos to Pax
                    tempPax.isAdded = true;
                    tempPax.booking = tnr.booking;


                    _set(this.nameLists[_index].booking.traveller, paxId, tempPax);

                    //Desactivate from origin
                    if (!this.s_listData.listDisabled[idList]) {
                        this.s_listData.listDisabled[idList] = [];
                    }
                    this.s_listData.listDisabled[idList].push(paxId);

                });
                //update "quantity.person" value
                if (this.nameLists[_index].booking.quantity.person) {
                    this.nameLists[_index].booking.quantity.person += paxIdList.length;
                }

            }
        });

    }


    public showAddPax(_namelist: any): boolean {
        let output = false;
        if (this.isJourney(_namelist)) {
            if ((_namelist.stock && _namelist.stock.Purchased.remaining !== 0 && this.isSelectedPax()) ||
                (_namelist.journey && _namelist.journey.booking.type === 'EXCEL')
            ) {
                output = true;
            }

        } else { // isPNR Air
            if (this.isSelectedPax()) {
                output = true;
            }
        }

        return output;
    }

    /**
     * removePax
     *
     * remove a Pax from desactivate origin list. launch from child eventEmitter
     *
     * @param {string} _event : index from pax List
     * @param {string} _index : index from tnr List
     */
    public removePax(_event: any, _index: number): void {

        const bookingOrigin = _cloneDeep(this.nameLists[_index].traveller[_event].booking);
        let tnrId: string;
        if (_isObject(bookingOrigin.code)) {
            tnrId = _values(bookingOrigin.code)[0];
        } else {
            tnrId = bookingOrigin.code;
        }

        this.s_listData.listDisabled[tnrId] = _pull(this.s_listData.listDisabled[tnrId], _event);
        _unset(this.nameLists[_index].traveller, _event);

        if (this.nameLists[_index].stock) {
            this.nameLists[_index].stock.Purchased.remaining =
                this.nameLists[_index].stock.Purchased.quantity - _keys(this.nameLists[_index].traveller).length;
        }
        this.tnrService.hideJourneyFlag(_event, tnrId);

    }

    public getPnrId(_journey: any): string {
        return _journey.booking.code;
    }

    /**
     * removeDisabled
     * remove disabled pax (from tnr list) to the list of pax to add
     */
    public removeDisabled(): any {
        const output: any = {};

        _forEach(this.s_listData.list, (value: any, key: string) => {
            let tempDiff: string[] = [];
            if (this.s_listData.listDisabled[key]) {
                tempDiff = _differenceBy(value, this.s_listData.listDisabled[key]);
            } else {
                tempDiff = value;

            }

            output[key] = tempDiff;
        });
        return output;
    }


    /**
     * countAddedPax
     *
     * count Number of added pax in a namelist. used to hide the 'send' button
     *
     * @param {number} _index : index of namelist
     */
    public countAddedPax(_index: number): number {
        if (this.isJourney(this.nameLists[_index])) {
            return this.countAddedPaxInJourney(_index);
        } else {
            return this.countAddedPaxInPnr(_index);

        }
    }


    public countAddedPaxInJourney(_index: number): number {
        let output = 0;
        const nbAddedPax = _filter(this.nameLists[_index].traveller, (o: any) => o.isAdded);

        if (nbAddedPax) {
            output += nbAddedPax.length;
        }
        return output;
    }

    public countAddedPaxInPnr(_index: number): number {
        let output = 0;
        const nbAddedPax = _filter(this.nameLists[_index].booking.traveller, (o: any) => o.isAdded);

        if (nbAddedPax) {
            output += nbAddedPax.length;
        }
        return output;
    }

    public startsWith(_str: string | INameList, _strStart: string): boolean {
        if (typeof _str === "string") {
            return _startsWith(_str, _strStart);
        }

        return false;
    }


    /**
     * newPnr
     */
    public newPnr(_actionName: string | INameList, _name?: string, _maxPax?: number, _futureNamelistIndex?: number): void {
        //empty Pnr
        const newPnr: any = {};

        //set created to true, to launch the "create" api
        _set(newPnr, 'created', true);
        _set(newPnr, 'topic', "Journey");

        //name in booking object
        let booking: any = {};
        let stock: any = {};
        let sectors: any = {};

        let bookingJourney = this.s_appData.bookingJourney ?? null;

        if (_futureNamelistIndex !== undefined) {
            bookingJourney = [Object.values(this.futureNamelists[_futureNamelistIndex])[0]];
            this.futureNamelists[_futureNamelistIndex].done = true;
            _set(newPnr, 'futurIndex', _futureNamelistIndex);
        }

        if (bookingJourney && bookingJourney[0]) {
            if (typeof (_actionName) != 'string') {
                _set(newPnr, 'exportType', _actionName.host);
            }

            this.bookingJourney = bookingJourney[0];

            if (_isString(_actionName) && _actionName === 'createPnrPassive') {
                booking = {
                    host: "GALILEO",
                    type: "PNR",
                    isPassive: true
                };
            } else if(_isString(_actionName) && _actionName === 'useActionType') {
                booking = {
                    host: "GALILEO",
                    type: "PNR",
                    isPassive: false,
                    code: _name
                };
            } else
             {
                booking = {
                    type: "NAMELIST",
                    host: (_actionName as { host: string }).host,
                };
            }

            const bookingStock = this.bookingJourney.stock;
            stock = {
                Purchased: {
                    quantity: bookingStock.Purchased.quantity,
                    remaining: bookingStock.Purchased.remaining
                },
                id: bookingStock.Purchased.id
            };
            sectors = this.bookingJourney.sector ?? null;

            _set(newPnr, 'journey.carrier', this.bookingJourney.journey.carrier ?? null);
            _set(newPnr, 'journey.from', this.bookingJourney.journey.from ?? null);
            _set(newPnr, 'journey.to', this.bookingJourney.journey.to ?? null);
            _set(newPnr, 'journey.begin', this.bookingJourney.journey.begin ?? null);
            _set(newPnr, 'journey.end', this.bookingJourney.journey.end ?? null);
            _set(newPnr, 'journey.direction', this.bookingJourney.journey.direction ?? null);
            _set(newPnr, 'sector', sectors);
        } else {
            //get datas from first tnr selected
            const sector = _futureNamelistIndex !== undefined ?
                this.futureNamelists[_futureNamelistIndex].data.sector : this.synchronymeService.data.reference.sector;
            const journey = _futureNamelistIndex !== undefined ?
                this.futureNamelists[_futureNamelistIndex].data.journey : this.synchronymeService.data.reference.journey;

            //set sectors and journey from first tnr selected
            _set(newPnr, 'sector', sector);
            _set(newPnr, 'journey', journey);

            if (_isString(_actionName) && _actionName === 'createPnrPassive') {
                booking = {
                    host: "GALILEO",
                    type: "PNR",
                    isPassive: true
                };
                stock = {
                    Purchased: {
                        quantity: _maxPax,
                        remaining: _maxPax
                    }
                };
            } else if (!_isString(_actionName)) {
                booking = {
                    type: "NAMELIST",
                    host: (_actionName as { host: string }).host,
                };
                stock = {
                    Purchased: {
                        quantity: 99,
                        remaining: 99
                    }
                };
            }
        }

        _set(newPnr, 'journey.booking', booking);
        _set(newPnr, 'stock', stock);

        console.log(newPnr);

        // add pnr in pnrlist
        this.nameLists.push(newPnr);
        //Add Pax
        this.addPax(this.nameLists.length - 1);
        this.f_showForm = false;
    }

    public showTnr(_event: any): void {
        const event = JSON.parse(_event);
        this.tnrService.showTnr(event.id);

        //TODO: compare all travellers from PNRLists wich have the same origin
    }

    /**
     *
     *
     * test if a param is present in collection object
     */
    public isParam(_collection: any, _path: string): boolean {
        _forEach(_collection, (_value: any): any => {
            if (_value[_path]) {
                return true;
            }
        });
        return false;
    }

    /* METHODS */

    /**
     * @method get
     * @param context {string}
     * @param ext {string}
     */
    public getApiLabels(context: string, ext?: string): string {
        const labelField = ext ? context + ext : context;
        return this.apiLabels[labelField];
    }

    /**
     * @description launch submit action for namelist
     * @method onFormSubmit
     */
    public onFormSubmit() {
        const startsWithUse = this.startsWith(this.actionName, 'use') ? 'useActionType' : undefined;
        const actionName = startsWithUse ? startsWithUse : this.actionName;

        switch (actionName) {
            case 'useActionType':
                if (this.inputPnr) {
                    this.getPnrList(this.inputPnr);
                }
                break;
            case 'createPnrPassive':
                if (this.quantityPnr > 0) {
                    this.newPnr(this.actionName, this.inputPnr, this.quantityPnr);
                }
                break;
            case 'createTigre':
                this.newPnr(this.actionName, this.inputPnr);
                break;
            default:
                this.newPnr(actionName);
                break;
        }
        this.quantityPnr = '';
    }

    public onFutureNamelistSubmit(index: number) {
        const startsWithUse = this.startsWith(this.futureActionName[index], 'use') ? 'useActionType' : undefined;
        const actionName = startsWithUse ? startsWithUse : this.futureActionName[index];

        switch (actionName) {
            case 'useActionType':
                if (this.futureInputPnr[index]) {
                    this.newPnr(actionName, this.futureInputPnr[index], null, index);
                    this.futureNamelists[index].done = true;
                }
                break;
            case 'createPnrPassive':
                if (this.futureQuantityPnr[index] > 0) {
                    this.newPnr(actionName, this.futureInputPnr[index], this.futureQuantityPnr[index], index);
                }
                break;
            case 'createTigre':
                this.newPnr(actionName, this.futureInputPnr[index], null, index);
                break;
            default:
                this.newPnr(actionName, null, null, index);
                break;
        }
        this.futureQuantityPnr[index] = null;
    }

    /**
     * getSold
     *
     * base json don't give sold quantity, so we need to calculate it from quantity and remaining values
     *
     * @param {any} _stock : whole stock object
     *
     * @return {number} : sold value
     */
    public getSold(_stock: any): number {
        let output: number;

        output = _stock.quantity - _stock.remaining;

        return output;
    }

    public changeActionStatus(context: string, status: IActionStatus) {
        const actionStatus = this.setActionStatus();

        actionStatus[context] = {...actionStatus[context], ...status};
        this.actionStatus = {...actionStatus};

    }

    public isActionANameList(): boolean {
        return this.actionName && typeof this.actionName !== "string";
    }

    public getFiles(nameList: string | INameList): Array<{ file: string, url: string }> {
        if (!nameList || typeof nameList === "string") {
            return [];
        }

        const journeyNameList: any = this.getNamelist(nameList);
        return journeyNameList.files;
    }

    public getWording(nameList: string | INameList): INameListWording {
        if (!nameList || typeof nameList === "string") {
            return null;
        }

        return nameList.wording;
    }

    public getFromFromSector(sectors: any): string {
        if (sectors) {
            const firstSector: any = Object.values(sectors)[0];
            return firstSector.from.airport !== undefined ? firstSector.from.airport.name : firstSector.from.name;
        }
        return '';
    }

    public getToFromSector(sectors: any): string {
        if (sectors) {
            const sectorsValues: any = Object.values(sectors);
            const lastSector: any = sectorsValues[sectorsValues.length - 1];
            return lastSector.to.airport !== undefined ? lastSector.to.airport.name : lastSector.to.name;
        }

        return '';
    }

    public getBegin(sectors: any): string {
        if (sectors) {
            const firstSector: any = Object.values(sectors)[0];
            return firstSector.begin;
        }

        return '';
    }

    /**
     * getTime
     *
     * get Time spend between now and last a past time
     * @TODO : EJ+2017+08+01 : make a pipe ?
     *
     * @param {number} _timestamp : past timestamp
     *
     * @return {string} : "humazised" value (ex : une heure)
     */
    protected getTime(_timestamp: number): string {
        _timestamp = _toNumber(_timestamp);
        const duration = moment.duration(moment().unix() - _timestamp, 'seconds');
        return duration.humanize();
    }


    // TODO => mettre en application les statuts pour les actions de pnrLIst
    private setActionStatus(): IActionsStatus {
        return {
            pending: {
                isCurrentStatus: false,
                index: null,
                type: null,
            },
            error: {
                isCurrentStatus: false,
                index: null,
                type: null,
            },
            success: {
                isCurrentStatus: false,
                index: null,
                type: null,
            },
        };
    }

    private getPnrCode(namelist) {
        if (_isString(namelist.booking.code)) {
            return namelist.booking.code;
        } else if (_isObject(namelist.booking.code)) {
            return _values(namelist.booking.code)[0];
        }
    }

    /**
     *
     * get booking info to inject in added pax in TNR origin
     */
    private getTempBooking(_namelist: any): any {
        const tempBooking: any = {};
        let journeyBooking;
        if (!_namelist.booking) {
            if (_keys(_namelist.journey.booking).length === 1) {
                journeyBooking = _values(_namelist.journey.booking)[0];
            } else {
                journeyBooking = _namelist.journey.booking;
            }
        } else {
            journeyBooking = _namelist.booking;
        }

        if (journeyBooking.host) {
            tempBooking.host = journeyBooking.host;
        }
        if (journeyBooking.code && _isString(journeyBooking.code)) {
            _set(tempBooking, 'code.' + journeyBooking.host, journeyBooking.code);
        }

        if (journeyBooking.document) {
            tempBooking.document = journeyBooking.document;
        }

        _set(tempBooking, 'type', journeyBooking.type);

        return tempBooking;
    }

    private getId(namelist) {
        if (namelist.topic === "Booking") {
            return this.getName(this.nameLists);
        } else if (namelist.topic === "Journey") {
            return namelist.journey.id;
        }
        return '';
    }


}

